import { decode, encode } from 'js-base64';

export const generate = (string) => {
  const base64 = encode(string);
  const token = encode(`${base64}+${process.env.REACT_APP_BASE64_KEY}`);

  return token;
};

export const readJson = (token) => {
  // console.log('token', token);
  const tokenDecode = decode(token);
  // console.log('tokenDecode', tokenDecode);

  const idEncode = tokenDecode.split('+')[0];
  // console.log('idEncode ', idEncode);

  const string = decode(idEncode);
  // console.log('string ', JSON.stringify(string));

  // const result = string.split('"')[0];
  // console.log('result ', result);

  return string;
};

export const read = (token) => {
  const tokenDecode = decode(token);
  const idEncode = tokenDecode.split('+')[0];
  const string = decode(idEncode);
  const id = parseInt(string.split('"')[0]);

  return id;
};
